import product from "./product";

export default {
    product,

    noAvailableItems: "Keine bestellbaren Produkte verfügbar."
}